<template lang="pug">
.info-miner.w100
  table.table.is-fullwidth.table-reward-stats
    tbody
      tr
        td 
          .w400 Mining balance
          .w100.s12 Balance obtained by mining via GPU / CPU / ASIC
        td.amount
          span#pending_mining_balance 
            i.fa.fa-circle-o-notch.fa-spin(v-if="isLoading")
            span(v-else) {{ stats.balance_mining }}
      tr
        td 
          .w400 Referral balance
          .w100.s12 Balance obtained by sharing your referral code
        td.amount
          span#pending_referral_balance
            i.fa.fa-circle-o-notch.fa-spin(v-if="isLoading")
            span(v-else)  {{ stats.balance_referral }}
      tr
        td 
          .w400 Total balance
          .w100.s12 Sum of mining + referral balance
        td.amount
          span.pending_balance
            i.fa.fa-circle-o-notch.fa-spin(v-if="isLoading")
            span(v-else)  {{ stats.balance }}
      tr
        td 
          .w400 Past 24 hours rewards
          .w100.s12 Total rewards obtained over the past 24 hours (updates hourly)
          .w100.s12 From {{ stats.rewarded_timestamp.past_24h[0] }} to {{ stats.rewarded_timestamp.past_24h[1] }}
        td.amount
          span#total_24h
            i.fa.fa-circle-o-notch.fa-spin(v-if="isLoading")
            span(v-else)  {{ stats.rewarded.past_24h }}
      tr
        td 
          .w400 Past 7 days rewards
          .w100.s12 Total rewards obtained over the past 7 days (updates hourly)
          .w100.s12 From {{ stats.rewarded_timestamp.past_7d[0] }} to {{ stats.rewarded_timestamp.past_7d[1] }}
        td.amount
          span#total_7d
            i.fa.fa-circle-o-notch.fa-spin(v-if="isLoading")
            span(v-else)  {{ stats.rewarded.past_7d }}
      tr
        td 
          .w400 Past 30 days rewards
          .w100.s12 Total rewards obtained over the past 30 days (updates hourly)
          .w100.s12 From {{ stats.rewarded_timestamp.past_30d[0] }} to {{ stats.rewarded_timestamp.past_30d[1] }}
        td.amount
          span#total_30d
            i.fa.fa-circle-o-notch.fa-spin(v-if="isLoading")
            span(v-else)  {{ stats.rewarded.past_30d }}
      tr
        td 
          .w400 Total Paid
          .w100.s12 Total paid to your wallet
        td.amount
          span#total_paid
            i.fa.fa-circle-o-notch.fa-spin(v-if="isLoading")
            span(v-else)  {{ stats.paid }}
      tr
        td 
          .w400 Last payment date
          .w100.s12 Last payment sent to your wallet
        td.amount
          span#last_payment_date
            i.fa.fa-circle-o-notch.fa-spin(v-if="isLoading")
            span(v-else)  {{ stats.last_payment_date }}
      tr
        td 
          .w400 Payment threshold
          .w100.s12 A payout can be processed once you reach the payment threshold
        td.amount
          span.threshold_amount
            i.fa.fa-circle-o-notch.fa-spin(v-if="isLoading")
            span(v-else)  {{ paymentThreshold }}
      tr
        td 
          .w400 Current mining fee
          .w100.s12 Fees can be reduced to 0.75% when a referral code is used.
        td.amount
          span.current-fee(v-if="miningFee == '0.75'") 0.75%
          span.current-fee(v-else) 1%
          i.fa.fa-circle-o-notch.fa-spin(v-if="isLoading")

</template>

<script>
import { apiGet } from '../util/general'
export default {
  name: 'c_tab_stats',
  props: ['paymentThreshold', 'miningFee', 'uuid'],
  data() {
    return {
      isLoading: false,
      stats: {
        balance: '',
        balance_mining: '',
        balance_referral: '',
        rewarded: {
          past_24h: '',
          past_7d: '',
          past_30d: ''
        },
        rewarded_timestamp: {
          past_24h: '',
          past_7d: '',
          past_30d: ''
        },
        paid: '',
        last_payment_date: ''
      }
    }
  },
  mounted() {
    let vm = this
    vm.fetch()
  },
  methods: {
    fetch() {
      let vm = this
      vm.isLoading = true
      vm.$emit('startLoading')

      let url = '/v5/account/' + vm.uuid + '/stats'
      let obj = {}
      apiGet(vm, url, obj, function (data) {
        vm.stats.balance = data.data.balance
        vm.stats.balance_mining = data.data.balance_mining
        vm.stats.balance_referral = data.data.balance_referral
        vm.stats.rewarded.past_24h = data.data.rewarded.past_24h
        vm.stats.rewarded.past_7d = data.data.rewarded.past_7d
        vm.stats.rewarded.past_30d = data.data.rewarded.past_30d
        vm.stats.rewarded_timestamp.past_24h = [ window.dayjs(data.data.rewarded_timestamp.past_24h[0]).format('MMM DD HH:mm'), window.dayjs(data.data.rewarded_timestamp.past_24h[1]).format('MMM DD HH:mm') ]
        vm.stats.rewarded_timestamp.past_7d = [ window.dayjs(data.data.rewarded_timestamp.past_7d[0]).format('MMM DD HH:mm'), window.dayjs(data.data.rewarded_timestamp.past_7d[1]).format('MMM DD HH:mm') ]
        vm.stats.rewarded_timestamp.past_30d = [ window.dayjs(data.data.rewarded_timestamp.past_30d[0]).format('MMM DD HH:mm'), window.dayjs(data.data.rewarded_timestamp.past_30d[1]).format('MMM DD HH:mm') ]
        vm.stats.paid = data.data.paid
        if (data.data.last_payment) {
          vm.stats.last_payment_date = window.dayjs(data.data.last_payment).format('YYYY-MM-DD HH:mm:ss')
        } else {
          vm.stats.last_payment_date = '-'
        }
      }, function (err) {
        console.error('Error:', err.message)
        vm.$store.dispatch('notifyError', err.message)
      }, function () {
        vm.isLoading = false
        vm.$emit('stopLoading')
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.table-reward-stats
  td, th
    padding .4em .2em
  tr td
    vertical-align: middle
  td.amount
    font-size: 23px;
    text-align: right;
    font-weight: 100;
</style>



// WEBPACK FOOTER //
// c_tab_stats.vue?42bdcf1a